import { render, staticRenderFns } from "./NotificationTable.vue?vue&type=template&id=f6c0ff4e&scoped=true"
import script from "./NotificationTable.vue?vue&type=script&lang=js"
export * from "./NotificationTable.vue?vue&type=script&lang=js"
import style0 from "./NotificationTable.vue?vue&type=style&index=0&id=f6c0ff4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c0ff4e",
  null
  
)

export default component.exports